import React from 'react';
import { Link } from "react-router-dom";
import { Label } from '../atoms/label';


export const SoloInputConfirmReserver = (props) => {

    const {
        reserverInfo
    } = props;

    return (
        <div className='soloConfirm_inputTextWrapper'>
            <div className='soloConfirm_inputTitleArea'>
                <Label label='利用者' className='soloConfirm_inputTitle' />
                <div className='soloConfirm_changeLinkDiv'>
                    <Link className='soloConfirm_changeLink' to="/reserve/golf/solouserInput">変更</Link>
                </div>
            </div>
            <div className='soloConfirm_inputTextForm' >
                <div className='soloConfirm_inputTextArea' >
                    <div className='soloConfirm_inputLabelGroup'>
                        <Label label='利用者氏名' className='soloConfirm_inputTitleLabel' />
                        <Label label={reserverInfo?.familyName + reserverInfo.firstName} className='soloConfirm_inputMail' />
                    </div>
                    <div className='soloConfirm_inputLabelGroup'>
                        <Label label='メールアドレス' className='soloConfirm_inputTitleLabel' />
                        <Label label={reserverInfo?.mailAddress} className='soloConfirm_inputMail' />
                    </div>
                    <div className='soloConfirm_inputLabelGroup'>
                        <Label label='電話番号' className='soloConfirm_inputTitleLabel' />
                        <Label label={reserverInfo?.phone} className='soloConfirm_inputLabel' />
                    </div>
                    <div className='soloConfirm_inputLabelGroup'>
                        <Label label='備考' className='soloConfirm_inputTitleLabel' />
                        <Label label={reserverInfo?.remark} className='soloConfirm_inputLabel' />
                    </div>
                </div>
                <div className='soloConfirm_changeLinkDiv2'>
                    <Link className='soloConfirm_changeLink' to="/reserve/golf/soloUserInput">変更</Link>
                </div>
            </div>
        </div>
    );
}